// extracted by mini-css-extract-plugin
export default {"Modal":"ESw4g_qu","scrollable":"qkb6H1p_","content":"NxhSG1qz","opened":"RuLiugLP","close":"MDpcmzhw","title":"b_IjUd1A","h1":"lfn0dfxD","h2":"yGt0JyIv"};